// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

// ** Handle User Login
export const handleLogin = data => {
  return dispatch => {
    dispatch({
      type: 'LOGIN',
      data,
      config,
      [config.storageTokenKeyName]: data[config.storageTokenKeyName],
      [config.storageRefreshTokenKeyName]: data[config.storageTokenKeyName]
    })

    const newLocalStorage = {folder: [], stimulus: []}
    localStorage.setItem('analysisDashboard', JSON.stringify(newLocalStorage))

    // ** Add to user, accessToken & refreshToken to localStorage
    localStorage.setItem('userData', JSON.stringify(data))
    localStorage.setItem(config.storageTokenKeyName, data.accessToken)
    localStorage.setItem(config.storageRefreshTokenKeyName, data.refreshToken)
  }
}

// ** Handle User Logout
export const handleLogout = () => {
  return dispatch => {
    dispatch({ type: 'LOGOUT', [config.storageTokenKeyName]: null, [config.storageRefreshTokenKeyName]: null })

    // ** Remove user, accessToken & refreshToken from localStorage
    localStorage.removeItem('predictAnalytics')
    localStorage.removeItem('analysisDashboard')
    localStorage.removeItem('analyzerTiloData')
    localStorage.removeItem('userData')
    localStorage.removeItem('troiatec')
    localStorage.removeItem(config.storageTokenKeyName)
    localStorage.removeItem(config.storageRefreshTokenKeyName)

  }
}

// ** Handle TiloPay Token
export const handleTilo = data => {
  return dispatch => {
    dispatch({ type: 'TILO_DATA', data })

    // ** Add Token to localStorage
    localStorage.setItem('analyzerTiloData', JSON.stringify(data))
  }
}

// ** Handle set Tour
export const handleTour = value => dispatch => dispatch({ type: 'HANDLE_TOUR', value })
export const handleRpassword = value => dispatch => dispatch({ type: 'HANDLE_RPASSWORD', value })
export const handleToken = value => dispatch => dispatch({ type: 'HANDLE_TOKEN', value })
export const handleBabel = value => dispatch => dispatch({ type: 'HANDLE_BABEL', value })
export const handleUserData = value => dispatch => dispatch({ type: 'HANDLE_USER_DATA', value })